import { render, staticRenderFns } from "./BuildConfig.vue?vue&type=template&id=f29abe9a&"
import script from "./BuildConfig.vue?vue&type=script&lang=js&"
export * from "./BuildConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports